/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/itpDefaultMessage.ts
 * FILE_ID: JOBHUB-QA-ITP-DEFAULT-MESSAGE-001
 * PURPOSE: The ITP email body used when the user has not saved their own.
 */
export const ITP_DEFAULT_MESSAGE = 'Hi,\n\nPlease find attached ITP report.\nAwaiting your feedback/decision.\n\nRegards,'

export function defaultItpMessage(name: string): string {
  const n = name.trim()
  return n ? `${ITP_DEFAULT_MESSAGE}\n${n}` : ITP_DEFAULT_MESSAGE
}
